import moment from 'moment';

export function statusTextEx(stage, cancelled) {
    switch (stage) {
        case 'OP':
        case 'IR':
        case 'AL':
            if (cancelled) {
                return 'CANCEL';
            }
            return 'Open';
        case 'CT':
            return 'Closed';
        default:
            return '';
    }
}

export function statusText(stage) {
    switch (stage) {
        case 'OP':
        case 'IR':
        case 'AL':
            return 'Open';
        case 'CT':
            return 'Closed';
        default:
            return '';
    }
}

export function isSType(stype, ticket) {
    let now = new Date().valueOf();
    let dd = new Date(ticket.duedate).valueOf();
    let timespan;
    switch (stype) {
        case 'grids':
            return ticket.TS_type[0] === '1';
        case 'polygons':
            return ticket.TS_type[1] === '1';
        case 'normal':
            return ticket.TS_type[2] === '1';
        case 'emergency':
            return ticket.TS_type[3] === '1';
        case 'damage':
            return ticket.TS_type[4] === '1';
        case 'short_notice':
            return ticket.TS_type[5] === '1';
        case 'rush':
            return ticket.TS_type[6] === '1';
        case 'late':
            return ticket.TS_type[7] === '1';
        case 'cancel':
            return (ticket.TS_type[8] === '1') || ticket.TS_cancelled;
        case 'update':
            return ticket.TS_type[9] === '1';
        case 'ongoing':
            return ticket.TS_type[10] === '1';
        case 'meet':
            return ticket.TS_type[11] === '1';
        case 'design':
            return ticket.TS_type[12] === '1';
        case 'remark':
            return ticket.TS_type[13] === '1';
        case 'second_notice':
            return ticket.TS_type[14] === '1';
        case 'noncompliant':
            return ticket.TS_type[15] === '1';
        case 'complex_project':
            return ticket.TS_type[16] === '1';
        case 'complex_project_meet':
            return ticket.TS_type[17] === '1';
        case 'resend':
            return ticket.TS_type[18] === '1';
        case 'complex_marking_deviation':
            return ticket.TS_type[19] === '1';
        case 'closeonly':
            return ticket.TS_type[20] === '1';
        case 'closed':
            return ticket.TR_stage === 'CT';
        case 'overdue':
            return dd < now;
        case 'due4':
            timespan = 4 * 1000 * 60 * 60; // 4 hours
            return (now < dd) && (dd <= (now + timespan));
        case 'due8':
            timespan = 8 * 1000 * 60 * 60; // 8 hours
            return (now < dd) && (dd <= (now + timespan));
        case 'due24':
            timespan = 24 * 1000 * 60 * 60; // 24 hours
            return (now < dd) && (dd <= (now + timespan));
        case 'due48':
            timespan = 48 * 1000 * 60 * 60; // 48 hours
            return (now < dd) && (dd <= (now + timespan));
    }
    return false;
}

export function formatTicketDate(dateString) {
    const date = new Date(dateString);
    return (date.getMonth() + 1).toString().padStart(2, '0') + '/'
        + date.getDate().toString().padStart(2, '0') + '/'
        + date.getFullYear();
}
export function formatTicketDateTime(dateString) {
    return moment(dateString).format('MM/DD/YYYY HH:mm A');
}

export const fieldHeaderMap = {
    center: {
        text: 'Center',   // catalog.center.label
        align: 'left',
        sortable: true,
        width: '68px'
    },
    received: {
        text: 'Received',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    ticket: {
        text: 'Ticket',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    revision: {
        text: 'Rev',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    type: {
        text: 'Type',
        align: 'left',
        sortable: true,
        width: '66px'
    },
    priority: {
        text: 'Pri',
        align: 'left',
        sortable: true,
        width: '100px'
    },
    category: {
        text: 'Cat',
        align: 'left',
        sortable: true,
        width: '81px'
    },
    lookup: {
        text: 'Lkup',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    ticket_date: {
        text: 'Ticket Date',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    expires_date: {
        text: 'Expires',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    old_ticket: {
        text: 'Old Ticket',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    state: {
        text: 'St',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    county: {
        text: 'County',
        align: 'left',
        sortable: true,
        width: '103px'
    },
    place: {
        text: 'Place',
        align: 'left',
        sortable: true,
        width: '103px'
    },
    subdivision: {
        text: 'Subdivision',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    address: {
        text: 'Address',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    street: {
        text: 'Street',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    intersection: {
        text: 'Inter',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    cross1: {
        text: 'Cross Street 1',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    cross2: {
        text: 'Cross Street 2',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    between_c1c2: {
        text: 'Between',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    caller_type: {
        text: 'Caller Type',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    company: {
        text: 'Company',
        align: 'left',
        sortable: true,
        width: '157px'
    },
    company_addr1: {
        text: 'Company Addr1',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    company_addr2: {
        text: 'Company Addr2',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    company_city: {
        text: 'Company City',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    company_state: {
        text: 'Company State',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    company_zip: {
        text: 'Company Zip',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    caller: {
        text: 'Caller',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    caller_phone: {
        text: 'Caller Phone',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    contact_name: {
        text: 'Contact Name',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    contact_phone: {
        text: 'Contact Phone',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    contact_name_alt: {
        text: 'Contact Name (Alt)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    contact_phone_alt: {
        text: 'Contact Phone (Alt)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    best_time: {
        text: 'Best-Time',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    email: {
        label: 'E-Mail',
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    duedate: {
        text: 'Due Date',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    dueDateText: {
        text: 'Due',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    work_date: {
        text: 'Work Date',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    work_end_date: {
        text: 'Work Ends',
        align: 'left',
        sortable: false,
        width: '80px'
    },
    work_type: {
        text: 'Work Type',
        align: 'left',
        sortable: true,
        width: '172px'
    },
    doneby: {
        text: 'Done By',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    donefor: {
        text: 'Done For',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    duration: {
        text: 'Duration',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    weekend: {
        text: 'Weekend',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    night: {
        text: 'Night',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    hours_notice: {
        text: 'HrsNotc',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    legal: {
        text: 'Legal',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    explosives: {
        text: 'Explosives',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    boring: {
        text: 'Boring',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    vacuum: {
        text: 'Vacuum',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    remark: {
        text: 'Remark',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    remark_type: {
        text: 'Remark Type',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    meet: {
        text: 'Meet',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    extended_job: {
        text: 'Ext-Job',
        sortable: true,
        width: '80px'
    },
    uob: {
        text: 'UOB',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    excavation_method: {
        text: 'Method',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    inside_outside: {
        text: 'In/Out',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    lot_number: {
        text: 'Lot',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    railroad: {
        text: 'RR',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    rr_mile_marker: {
        text: 'RR Marker',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    milepost_from: {
        text: 'RR-MP From',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    milepost_to: {
        text: 'RR-MP To',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    whitelined: {
        text: 'Whitelined',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    work_order_type: {
        text: 'W/O Type',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    work_order_number: {
        text: 'W/O #',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    permit: {
        text: 'Permit',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    delineated: {
        text: 'Delineated',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    delineated_method: {
        text: 'Delineated Method',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    excav_st_sidewalk: {
        text: 'Excav St/Sidewalk',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    instructions: {
        text: 'Instructions',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    latitude: {
        text: 'Caller Latitude',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    longitude: {
        text: 'Caller Longitude',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    ref_grid: {
        text: 'Reference Grid',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_x1: {
        text: 'BF(X1)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_x2: {
        text: 'BF(X2)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_x3: {
        text: 'BF(X3)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_x4: {
        text: 'BF(X4)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_y1: {
        text: 'BF(Y1)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_y2: {
        text: 'BF(Y2)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_y3: {
        text: 'BF(Y3)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    bestfit_y4: {
        text: 'BF(Y4)',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_grids: {
        text: 'Grids?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_polygons: {
        text: 'Poly?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_normal: {
        text: 'Norm?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_emergency: {
        text: 'Emer?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_damage: {
        text: 'Damg?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_short: {
        text: 'Short?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_rush: {
        text: 'Rush?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_late: {
        text: 'Late?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_cancel: {
        text: 'Cncl?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_update: {
        text: 'Updt?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_ongoing: {
        text: 'Ongoing?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_meet: {
        text: 'Meet?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_design: {
        text: 'Dsgn?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_remark: {
        text: 'Re-Mark?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_2ndnotice: {
        text: '2nd Notc?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    prop_noncompliant: {
        text: 'Nonc?',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    response_required: {
        text: 'Req?',
        align: 'left',
        sortable: false,
        width: '40px'
    },
    url: {
        text: 'URL',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    full_address: {
        text: 'Full Address',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    address_label: {
        text: 'Address Label',
        align: 'left',
        sortable: true,
        width: '160px'
    },
    TR_excavator_reply_disposition: {
        text: 'Excavator Reply',
        align: 'left',
        sortable: true,
        width: '160px'
    },
    polygon_count: {
        text: '#Poly',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    grid_count: {
        text: '#Grid',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    grids: {
        text: 'Grids',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    location: {
        text: 'Location',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    remarks: {
        text: 'Remarks',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    members: {
        text: 'Members',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    sys_id: {
        text: 'SysID',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_stage: {
        text: '(S) Stage',
        sortable: true,
        width: '80px'
    },
    TS_posted: {
        text: '(S)Posted',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_posted_by: {
        text: '(S)PostedBy',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_updated: {
        text: '(S)Updated',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_updated_by: {
        text: '(S)UpdatedBy',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_viewed_last: {
        text: '(S)LastViewed',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_viewed_last_by: {
        text: '(S)LastViewedBy',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_fips: {
        text: 'FIPS',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_ticket_new: {
        text: 'New Ticket',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_revision_latest: {
        text: '(S)LatestRev',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_lat_min: {
        text: '(S)LatMin',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_long_min: {
        text: '(S)LongMin',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_lat_max: {
        text: '(S)LatMax',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TS_long_max: {
        text: '(S)LongMax',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_seq_date: {
        text: 'Seq Date',
        align: 'left',
        sortable: true,
        width: '81px'
    },
    TR_seq_num: {
        text: 'Seq#',
        align: 'left',
        sortable: true,
        width: '81px'
    },
    TR_member_code: {
        text: 'Member',
        align: 'left',
        sortable: true,
        width: '118px'
    },
    TR_prop_autoassigned: {
        text: 'AutoAssgn',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_prop_autoresponded: {
        text: 'AutoResp',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_locator: {
        text: 'Locator',
        align: 'left',
        sortable: true,
        width: '120px'
    },
    TR_response_code: {
        text: 'Response',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_response_date: {
        text: 'Response Date',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_response_by: {
        text: 'Response By',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_date_located: {
        text: 'Located Date',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_work_done: {
        text: 'Work Done',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_updated: {
        text: 'Last Updated',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_updated_by: {
        text: 'Last Updated By',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_stage: {
        text: 'Status',
        align: 'left',
        sortable: true,
        width: '80px'
    },
    TR_insight_risk_score: {
        text: 'Risk',
        align: 'center',
        sortable: true,
        width: '80px'
    },
};

export const defaultTicketFields = 'TR_stage,duedate,center,TR_member_code,ticket,revision,type,priority,TR_seq_date,TR_seq_num,TR_locator,county,place,company,work_type';
export const defaultClipboardFields= 'center,TR_member_code,ticket,revision,type,priority,TR_seq_date,TR_seq_num,TR_locator,county,place,company,work_type';
export const defaultTicketFilters = {
    center: '*',
    member_code: '*',
    seq_date: '*',
    stype: '*',
    priority: '*',
    type: '*',
    category: '*',
    TR_stage: '*',
    fips: '*',
    locator: '*',
    due: '*'    
};

export const defaultFiltersDisplay = {
    center: true,
    member_code: true,
    seq_date: true,
    stype: true,
    priority: true,
    type: true,
    category: true,
    TR_stage: true,
    fips: true,
    locator: true,
    due: true
};

export const defaultOpenTicketsTabOptions = {
    tabClass: 'open-tickets',
    tabMoniker: '',
    tabId: 'open-tickets',
    label: 'Tickets',
    config: {
        autoRefreshMinutes: 0,
        pageSize: 100,
        orderBy: 'seq_date-asc',
        orderByDefault: 'seq_date-asc',
        fields: defaultTicketFields,
        filters: defaultTicketFilters,
        filtersDisplay: defaultFiltersDisplay,
    },
};
export const defaultClipboardTabOptions = {
    tabClass: 'tickets-clipboard',
    tabMoniker: '',
    tabId: 'tickets-clipboard',
    label: 'Clipboard',
    icon: 'fa-clipboard',
    multi: false,
    config: {
        fields: ''
    }
};
